<div class="card">
    <div class="card-body">
      
      <div class="d-flex mb-3">
        <h4 class="card-title">Categories</h4>
        <button type="button" class="btn btn-primary ms-auto" (click)="addNewModal()">
          Add New
        </button>
      </div>
	
      <ng-template #basicActions let-data="adtData" let-emitter="captureEvents">
        <app-basic-actions [data]="data" (emitter)="emitter($event)"></app-basic-actions>
      </ng-template>

      <app-admin-new-category [modalid]="modalid" [category]="editCategory" (newItemEvent)="changeData($event)"></app-admin-new-category>
      <app-admin-common-delete [modalid]="modalid1" table="category" [id]="deleteid" (newItemEvent)="changeData($event)"></app-admin-common-delete>
      <!-- <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover"></table> -->
      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table"></table>
    </div>
</div>